import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns">
      <Header />

      <main>
        <section
          id="shopify-section-template--19720760099028__main"
          className="shopify-section section"
        >
          <div className="page-width page-width--narrow section--padding">
            <h1 className="main-page-title page-title h1 text-center">
              <motion-element className="inline-flex" data-motion="fade-up">
                Return Policy
              </motion-element>
            </h1>
            <br />
            <div className="page__content rte">
              <p>
                Cartnovabin offers 30 day return policy, all orders except final
                sale products can be request for return within 30 days after
                receiving your items.
              </p>
              <p>
                To be eligible for a return, your item must be in the same
                condition that you received it, unworn or unused, with tags, and
                in its original packaging.&nbsp;Please print out the receipt or
                proof of purchase.
              </p>

              <p>
                Please follow the on-screen process to request for your
                return.&nbsp;
              </p>
              <p>
                You must return the items in the original box. The box should be
                undamaged, with no tape or labels attached.&nbsp;If you return
                the item with a damaged box or with tape your return will be
                rejected all together.
              </p>
              <p>
                Please allow 7 days processing time for the refund to be issued
                back to your&nbsp;original payment method.
              </p>
              <p>
                <strong>International&nbsp;</strong>
                <br />
                <span>
                  We currently don't accept&nbsp;international returns.
                </span>
              </p>
              <p>
                <span>
                  <b>Out Of Continental U.S. Returns</b>
                  <br />
                  We currently don't accept&nbsp;returns from Alaska, Hawaii,
                  Puerto Rico or military base addresses.
                </span>
              </p>
              <p>
                <strong>Damages and issues</strong>
                <br />
                Please inspect your order upon reception and contact us
                immediately if the item is defective, damaged or if you receive
                the wrong item, so that we can evaluate the issue and make it
                right.
              </p>
              <p>
                <br />
              </p>
              <p>
                <strong>Exceptions / non-returnable items</strong>
                <br />
                Certain types of items cannot be returned, like perishable goods
                (such as food, flowers, or plants), custom products (such as
                special orders or personalized items), and personal care goods
                (such as beauty products). We also do not accept returns for
                hazardous materials, flammable liquids, or gases. Please get in
                touch if you have questions or concerns about your specific
                item.
                <br />
                <br />
                Unfortunately, we cannot accept returns on sale items or gift
                cards.
              </p>
              <p>
                <br />
              </p>
              <p>
                <strong>Exchanges</strong>
                <br />
                The fastest way to ensure you get what you want is to return the
                item you have, and once the return is accepted, make a separate
                purchase for the new item.
              </p>
              <p>
                <br />
              </p>
              <p>
                <strong>Refunds</strong>
                <br />
                We will notify you once we’ve received and inspected your
                return, and let you know if the refund was approved or not. If
                approved, you’ll be automatically refunded on your original
                payment method. Please remember it can take some time for your
                bank or credit card company to process and post the refund too.
              </p>
              <p>
                <br />
                You can always contact us for any return question at
                <span>&nbsp;</span>
                <a href="mailto:cart@cartnovabin.shop">cart@cartnovabin.shop</a>
                .
              </p>
              <p>&nbsp;</p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Returns;
